// extracted by mini-css-extract-plugin
export default {"centered":"TablePropertiesBody_centered__j4Jog","message":"TablePropertiesBody_message__hJloc"};